import { createSlice } from '@reduxjs/toolkit';
import { DEFAULT_PAGE_SIZE, ORDER_STATUS } from '@src/constants/common';
import { dateArrayToDateString } from '@utils';
import { DATE_RANGE } from '@src/constants/options';

export const defaultSearchParams = {
  status: [ORDER_STATUS.SHIPMENT_WAIT, ORDER_STATUS.BEFORE_SHIPPING_DELAY],
  page: 1,
  date: dateArrayToDateString(DATE_RANGE.ONE_MONTH.value),
  limit: localStorage.getItem('searchPaymentWait') || DEFAULT_PAGE_SIZE,
  count: 1,
};

export const { actions, reducer } = createSlice({
  name: 'shipment',
  initialState: {
    searchParams: defaultSearchParams,
  },
  reducers: {
    changeSearchParams: (state, { payload }) => {
      state.searchParams = {
        ...state.searchParams,
        ...payload,
      };
    },
  },
});

export const { changeSearchParams } = actions;

export default reducer;
